import { render, staticRenderFns } from "./ConfiguratorSlider.vue?vue&type=template&id=10c62c19&"
import script from "./ConfiguratorSlider.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports